import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Paper, Typography, Grid, Button } from "@material-ui/core";
import config from "../../config";
import { DEV_TOOLS, devToolPath } from "./registry";

const PROD_ENVS = new Set(["production", "prod"]);

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
    maxWidth: 960,
    margin: "0 auto",
  },
  card: {
    padding: theme.spacing(3),
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  description: {
    flex: 1,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
}));

export default function DevToolsIndexPage() {
  const classes = useStyles();
  const history = useHistory();
  const isProduction = PROD_ENVS.has(config.appEnv);

  useEffect(() => {
    if (isProduction) history.replace("/");
  }, [isProduction, history]);

  if (isProduction) return null;

  return (
    <Box className={classes.root}>
      <Typography variant="h4" gutterBottom>
        Dev Tools
      </Typography>
      <Typography variant="body2" color="textSecondary" gutterBottom>
        QA/engineering helpers. Disabled in production.
      </Typography>

      <Grid container spacing={3} style={{ marginTop: 8 }}>
        {DEV_TOOLS.map((tool) => (
          <Grid item xs={12} sm={6} md={4} key={tool.slug}>
            <Paper className={classes.card}>
              <Typography variant="h6">{tool.title}</Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                className={classes.description}
              >
                {tool.description}
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={() => history.push(devToolPath(tool.slug))}
              >
                Open
              </Button>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
